interface ArrayResponse<T> {
  data: Array<{ id: string; attributes: T }>;
}

interface Response<T> {
  data: { id: string; attributes: T };
}

export function parseResponse<T>(response?: Response<T>): T {
  return response?.data?.attributes as T;
}

export function parseArrayResponse<T>(response?: ArrayResponse<T>): Array<T> {
  const list =
    response?.data && Array.isArray(response?.data) ? response.data : [];
  return list.map((item) => item.attributes) as Array<T>;
}

export function parseErrorResponse(error: Error): string {
  return error?.message;
}

export function parsePaginatedResponse<T>(
  response?: Array<ArrayResponse<T>>
): Array<T> {
  if (!response || !Array.isArray(response)) return [];
  const initialValue: Array<T> = [];
  return response.reduce((fullList, list) => {
    return [...fullList, ...parseArrayResponse(list)];
  }, initialValue);
}
